import { viperApi, clinicalApiPath } from '@/services/viper-api'
import qs from 'qs'

export class TrialSummaryService {
  /**
   * Constructs TrialSummaryService
   * @param api {AxiosInstance}
   * @param basePath {String}
   */
  constructor(api, basePath) {
    this.api = api
    this.basePath = basePath
  }

  /**
   * Retrieves a list of trial summaries for user's organization
   * @param params summaryValues list of values from summary-value-helper
   * @returns {Promise<any>}
   */
  listTrialSummaries(params) {
    return this.api.get(`${this.basePath}/trial-summaries`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
      }
    })
  }

  /**
   * Retrieves a list of trial summary trends
   * @param params end date and trialId
   * @returns {Promise<any>}
   */
  listTrialSummaryTrends(params) {
    return this.api.get(`${this.basePath}/trial-summaries/trends`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
      }
    })
  }

  /**
   * Retrieves counts of patients by trial identification status detail
   * @param params requiring trialId, and value (TrialIdentificationStatusValue), and orgId
   * @returns {Promise<any>}
   */
  listTrialSummaryStatusCounts(params) {
    return this.api.get(`${this.basePath}/trial-summaries/status-counts?${qs.stringify(params)}`)
  }

  /**
   * Returns not eligible counts
   * @param params map of endDate, orgId and optionally trialId
   * @returns {Promise<AxiosResponse<T>>}
   */
  getNotEligibleCounts(params) {
    return this.api.get(
      `${this.basePath}/trial-summaries/not-eligible-counts?${qs.stringify(params)}`
    )
  }

  potentialOrganizationTrialSummary(nctId, params) {
    return this.api.get(`${this.basePath}/trial-summaries/potential/trial/${nctId}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
      }
    })
  }

  potentialParentTrialSummary(nctId, params) {
    return this.api.get(`${this.basePath}/trial-summaries/potential/parent-trial/${nctId}`, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
      }
    })
  }

  /**
   * Returns number of patients per not eligible reason
   * @param params orgId, trialId
   * @returns {Promise<AxiosResponse<T>>}
   */
  getNotEligibleReasonCounts(params) {
    return this.api.get(
      `${this.basePath}/trial-summaries/not-eligible-reasons?${qs.stringify(params)}`
    )
  }
}

export default new TrialSummaryService(viperApi, clinicalApiPath)
